export const enum OfficeExtensionsEnum {
  Doc = 'doc',
  Docx = 'docx',
  Xls = 'xls',
  Xlsx = 'xlsx',
  Xlsm = 'xlsm',
  Ppt = 'ppt',
  Pptx = 'pptx',
}
